<template>
</template>
<script>
    import { otpHost } from "config/env.conf";
    import { Package_Order_Interval } from "config/packageProduct";
    import { getConfirmOrders } from "api/packageproduct";
    let storageKey = "3f.orderToastedList";
    export default {
        data: function () {
            return {};
        },
        created() {
            this.timerId = null;
            this.timerId = window.setInterval(() => {
                this.getConfirmOrders();
            }, Package_Order_Interval);
            this.getConfirmOrders();
        },
        methods: {
            getConfirmOrders() {
                getConfirmOrders().then(data => {
                    let orderNum = (data.pageInfo && data.pageInfo.dataNum) || 0;
                    if (orderNum > 0) {
                        this.showConfirmOrdersDialog(orderNum, data.orderListInfos);
                    }
                    this.$store.state.jiuJingConfirmOrders = orderNum;
                });
            },
            showConfirmOrdersDialog(totalOrderNum, orderList) {
                let handledOrdersStr = window.localStorage.getItem(storageKey);
                let handledOrders = [];
                if (handledOrdersStr) {
                    handledOrders = JSON.parse(handledOrdersStr);
                }
                let newOrders = [];
                if (handledOrders && handledOrders.length) {
                    orderList.forEach(orderItem => {
                        let isNewOrder = handledOrders.find(orderId => {
                            return orderId === orderItem.orderId;
                        })
                            ? false
                            : true;
                        if (isNewOrder) {
                            newOrders.push(orderItem.orderId);
                        }
                    });
                } else {
                    newOrders = orderList.map(orderItem => {
                        return orderItem.orderId;
                    });
                }
                if (newOrders && newOrders.length) {
                    let hasMore = totalOrderNum > orderList.length ? true : false;
                    this.$Player.play("https://s0.meituan.net/ecom/voice/hotel-poll.mp3");
                    this.$TitleMessager.show("您有新的酒景待确认订单需要处理");
                    let self = this;
                    window.localStorage.setItem(
                        storageKey,
                        JSON.stringify(handledOrders.concat(newOrders))
                    );
                    this.$Modal.info({
                        title: "酒景待确认订单列表",
                        scrollable: true,
                        closable: false,
                        render: h => {
                            return h("OrdersInDialog", {
                                props: {
                                    hasMore: hasMore,
                                    orders: newOrders
                                }
                            });
                        },
                        onOk: function () {
                            self.$Player.stop();
                            self.$TitleMessager.reset();
                        }
                    });
                }
            }
        },
        destroyed() {
            if (this.timerId) {
                window.clearInterval(this.timerId);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ConfirmOrders.vue?0239fb12